<div class="common-container-table__block-dashboard h-[684px]">
  <div class="common-container-table__block-header">
    <div class="common-section-title__dp-container">
      <span class="common-section-title__dp-label-text">{{evaluationsList.title}}</span>
      <div class="common-section-title__dp-buttons-container">
        @if((productSelected?.productId === 'blanqueo' || productSelected?.productId ==='denunc' || (dashboardVersion === 2 && skin !== 'icam-red')) && canCreate){
          <button class="common-button__icon-lg-border"
            (click)="exportList()"
            pTooltip="{{'evaluations-list.export-full-list' | afTranslate}}"
            tooltipPosition="left">
            <i class="lf-icon-send common-icon__md"></i>
          </button>
        }
        @if(canCreate){
          <button
            class="common-button__icon-lg"
            (click)="createNewEvaluation()"
            pTooltip="{{'new-evaluation.new-implantation' | afTranslate}}"
            tooltipPosition="left">
            <i class="lf-icon-add-round common-icon__md"></i>
          </button>
        }
      </div>
    </div>
    @if(!evaluationsList.closeAdviseHasDemo && evaluationsList.evaluationWithDemo){
      <div class="common-status-message__g-container-info">
        <i class="lf-icon-info-full common-status-message__icon-md"></i>
        <div class="common-status-message__g-content">
          <div class="common-status-message__g-icon-text-content">
            <div class="common-status-message__g-title-subtitle">
              <span class="common-status-message__g-subtitle"
                [afTranslate]="'evaluations-list.demo-evaluation'">
                _Te ofrecemos una implantación guía que te sirva como ejemplo para trabajar con Centinela Compliance Penal. Podrás crear una copia para empezar a editarla con tu información.
              </span>
            </div>
            <button class="common-button__icon-xs-noborder"
              (click)="closeAdviseHasDemo()">
                <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
          </div>
        </div>
      </div>
    }
    @if(evaluationsList.view === 'deleted'){
      <div class="common-status-message__g-container-info w-full">
        <i class="lf-icon-info-full common-status-message__icon-md"></i>
        <span-tooltip class="common-status-message__g-only-subtitle"
          [text]="'evaluations-list.message-alert-deleted' | afTranslate"></span-tooltip>
      </div>
    }
    <div class="common-table-items-container__block-container">
      <div class="evaluations-list__tabs-container-special"
        [ngClass]="{'evaluations-list__tabs-container-special--visible': evaluationsList.evaluationView?.length <= 3}">
        <div class="common-tab__secondary-list-block">
          @for (view of evaluationsList.evaluationView; track view.viewOption){
            <button (click)="changeViewEmit(view.viewOption)"
              class="common-tab__secondary"
              [ngClass]="{'common-tab__secondary--selected':view.viewOption === evaluationsList.selectedView.viewOption}">
              <p class="common-tab__secondary-button-text">{{view.name}}</p>
            </button>
          }
        </div>
      </div>
      <div class="evaluations-list__dropdown-view"
        [ngClass]="{'evaluations-list__dropdown-view--visible': evaluationsList.evaluationView?.length > 3}">
        <button-with-text-menu-arrow
          [item]="evaluationsList.evaluationViewItem"
          [list]="evaluationsList.evaluationView"
          [selectedOption]="evaluationsList.selectedView"
          (launchActionEmitter)="changeViewEmit($event.option.viewOption)">
        </button-with-text-menu-arrow>
      </div>
      <div class="common-table-items-container__search-field">
        <div class="common-search__container-tonal">
          <div class="common-search__container-input-text">
            <input type="search"
              class="common-search__input-text"
              [(ngModel)]="evaluationsList.searchEvaluation"
              (keyup)="searchList()"
              placeholder="{{'common.search-item' | afTranslate}}">
          </div>
          <div class="common-search__block-button-search">
            @if(evaluationsList.searchEvaluation){
              <button class="common-button__icon-xs-noborder"
                (click)="cleanFilter()">
                <i class="lf-icon-close-thick common-icon__sm"></i>
              </button>
            }
            <div class="h-[22px]"
                ngClass="{{evaluationsList.searchEvaluation?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}"></div>
            <i class="lf-icon-search common-icon__md"
                ngClass="{{!evaluationsList.searchEvaluation?'common-search__icon-search-disabled':'common-search__icon-search-enabled'}}"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="common-table__container-with-footer">
    @if (productSelected?.productId !== 'blanqueo'){
      <div class="common-table__container">
        <div class="common-table-header__container">
            <div class="common-table-body__inner-row w-[calc(100%-30px)]">
              @if(dashboardVersion === 1 && evaluationsList.view === 'shared'){
                <div class="common-table-cell__container w-[32%]">
                  <span-tooltip class="common-table-cell__title-text-label"
                    [text]="'common.participant' | afTranslate"></span-tooltip>
                </div>
              }
              <div class="common-table-cell__container w-[38%]">
                <filter-by-search-and-order
                  [item]="evaluationsList.nameFilter"
                  [filterOrder]="evaluationsList.filterOrder"
                  [order]="evaluationsList.order"
                  (launchActionFilterOrderEmit)="filterOrder($event, 'name')">
                </filter-by-search-and-order>
              </div>
              <div class="common-table-cell__container w-[30%]">
                <filter-by-list-and-order
                  [item]="evaluationsList.clientNameFilter"
                  [list]="evaluationsList.clientNameList"
                  [filterOrder]="evaluationsList.filterOrder"
                  [order]="evaluationsList.order"
                  (launchActionFilterOrderEmit)="filterOrder($event, 'clientName')">
                </filter-by-list-and-order>
              </div>
              @if(evaluationsList.view === 'all' && (dashboardVersion === 2 || productSelected?.productId ==='denunc')){
                <div class="common-table-cell__container"
                  [ngClass]="skin === 'icam-red'?'w-[32%]':'w-[16%]'">
                  <filter-by-order
                    [item]="evaluationsList.complaintsFilter"
                    [filterOrder]="evaluationsList.filterOrder"
                    [order]="evaluationsList.order"
                    (launchActionFilterOrderEmit)="filterOrder($event, 'complaints')">
                  </filter-by-order>
                </div>
                @if (skin !== 'icam-red') {
                  <div class="common-table-cell__container w-[16%]">
                    <filter-by-order
                      [item]="evaluationsList.publishDateFilter"
                      [filterOrder]="evaluationsList.filterOrder"
                      [order]="evaluationsList.order"
                      (launchActionFilterOrderEmit)="filterOrder($event, 'publishDate')">
                    </filter-by-order>
                  </div>
                }
              }@else if(dashboardVersion === 1 && evaluationsList.view === 'all'){
                <div class="common-table-cell__container w-[32%]">
                  <span-tooltip class="common-table-cell__title-text-label"
                    [text]="'common.state' | afTranslate"></span-tooltip>
                </div>
              }@else if(dashboardVersion === 1 && evaluationsList.view === 'deleted'){
                <div class="common-table-cell__container w-[32%]">
                  <span-tooltip class="common-table-cell__title-text-label"
                    [text]="'evaluations-list.delete-date' | afTranslate"></span-tooltip>
                </div>
              }
            </div>
        </div>
        <div class="common-table-body__container-auto">
            @for (evaluation of evaluationsList.evaluationsListFilter | byWord:evaluationsList.searchEvaluation:evaluationsList.filterTypes | afOrderByWithDesc:[{type:'isDemo', direction:evaluationsList.order?'asc':'desc'}, evaluationsList.orderElement]:evaluationsList.order | afLimitTo:evaluationsList.configPagination.itemsPerPage:evaluationsList.configPagination.firstElement; track evaluation.evaluationId){
              <div class="common-table-body__row"
                  [ngClass]="{'common-table-body__row--active': evaluation.openMenuAction}">
                  <div class="common-table-body__inner-row w-[calc(100%-30px)]"
                    (click)="clickRow(evaluation)">
                    @if(dashboardVersion === 1 && evaluationsList.view === 'shared'){
                      <div class="common-table-cell__container w-[32%]">
                        @if (evaluation.shared && evaluation.shared.length){
                          <participants-list [participants]="evaluation.shared"
                            [type]="'evaluation'">
                          </participants-list>
                        }
                      </div>
                    }
                    <div class="common-table-cell__container w-[38%]">
                      @if (evaluation.isDemo){
                        <div class="common-tag__container-tag">
                          <div class="common-tag__state-task common-tag__state-task--grey">
                            <span-tooltip class="common-tag__state-task-text"
                              [text]="evaluation.name"></span-tooltip>
                          </div>
                        </div>
                      }@else {
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="evaluation.name"></span-tooltip>
                      }
                    </div>
                    <div class="common-table-cell__container w-[30%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="evaluation.clientName"></span-tooltip>
                    </div>
                    @if(evaluationsList.view === 'all' && (dashboardVersion === 2 || productSelected?.productId ==='denunc')){
                      <div class="common-table-cell__container"
                        [ngClass]="skin === 'icam-red'?'w-[32%]':'w-[16%]'">
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="evaluation.complaints"></span-tooltip>
                      </div>
                      @if (skin !== 'icam-red') {
                        <div class="common-table-cell__container w-[16%]">
                          @if(evaluation.publishDate || !evaluation.publicShared){
                            <span-tooltip class="common-table-cell__standard-text-label"
                              [text]="evaluation.publishDate?(evaluation.publishDate | convertDate: 'without-time'):('evaluations-list.unpublished' | afTranslate)"></span-tooltip>
                          }
                        </div>
                      }
                    }@else if(dashboardVersion === 1 && evaluationsList.view === 'all'){
                      <div class="common-table-cell__container w-[32%]">
                        <div class="common-table-cell__progress-indicator w-full">
                          <span class="common-table-cell__progress-indicator-label">{{evaluation.progress}}%</span>
                          <div class="common-progress-indicator__bar-block h-[8px] max-w-[82px]">
                            @if (evaluation.progress) {
                              <div class="common-progress-indicator__bar-inner"
                                [ngStyle]="{'width': evaluation.progress+'%'}"></div>
                            }
                          </div>
                        </div>
                      </div>
                    }@else if(dashboardVersion === 1 && evaluationsList.view === 'deleted'){
                      <div class="common-table-cell__container w-[32%]">
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="evaluation.deletionDate | convertDate: 'without-time'"></span-tooltip>
                      </div>
                    }
                  </div>
                  @if ((evaluationsList.view !== 'deleted' && evaluation.canManage) || evaluation.isDemo){
                    <div class="common-table-cell__container-actions w-[30px]"
                      [id]="'evaluation-action-menu-'+evaluation.evaluationId">
                      <button-with-menu-action
                        [item]="evaluation"
                        [multiline]="1"
                        (configureMenuEmitter)="openActionEvaluation(evaluation)"
                        (launchActionEmitter)="selectOption($event.action, evaluation)">
                      </button-with-menu-action>
                    </div>
                  }@else if(evaluationsList.view === 'deleted' && evaluation.canManage){
                    <div class="common-table-cell__container-actions w-[30px]">
                      <button class="common-button__icon-md-noborder"
                        pTooltip="{{'common.remove' | afTranslate}}"
                        tooltipPosition="bottom"
                        (click)="deleteEvaluation(evaluation)">
                        <i class="lf-icon-trash common-icon__md"></i>
                      </button>
                    </div>
                  }
              </div>
            }@empty {
              <div class="common-empty-state__message-container">{{emptyMessage()}}</div>
            }
        </div>
      </div>
    }@else{
      <div class="common-table__container">
        <div class="common-table-header__container">
          <div class="common-table-body__inner-row"
            [ngClass]="evaluationsList.view === 'deleted'?'w-[calc(100%-30px)]':'w-[calc(100%-62px)]'">
            <div class="common-table-cell__container w-[25%]">
              <filter-by-list-and-order
                [item]="evaluationsList.clientNameFilter"
                [list]="evaluationsList.clientNameList"
                (launchActionFilterOrderEmit)="filterOrder($event, 'clientName')">
              </filter-by-list-and-order>
            </div>
            <div class="common-table-cell__container w-[calc(25%-30px)]">
              <filter-by-search-and-order
                [item]="evaluationsList.nameFilter"
                (launchActionFilterOrderEmit)="filterOrder($event, 'name')">
              </filter-by-search-and-order>
            </div>
            <div class="common-table-cell__container w-[30px]"></div>
            <div class="common-table-cell__container w-[25%]">
              <filter-by-list-and-order
                [item]="evaluationsList.resultFilter"
                [list]="evaluationsList.resultList"
                (launchActionFilterOrderEmit)="filterOrder($event, 'result')">
              </filter-by-list-and-order>
            </div>
            <div class="common-table-cell__container w-[25%]">
              <filter-by-order
                [item]="evaluationsList.modifiedFilter"
                [filterOrder]="evaluationsList.filterOrder"
                [order]="evaluationsList.order"
                (launchActionFilterOrderEmit)="filterOrder($event, 'modified')">
              </filter-by-order>
            </div>
          </div>
        </div>
        <div class="common-table-body__container-auto">
            @if (!evaluationsList.amountElements) {
              <div class="common-empty-state__message-container">{{emptyMessage()}}</div>
            }
            @if (evaluationsList.view === 'groupClients'){
              <div class="common-table-body__container-inner">
                @for (client of evaluationsList.clientsListFilter | byWordChildren:evaluationsList.searchEvaluation:evaluationsList.filterTypes:'evaluations' | afOrderBy:['clientName']:false | afLimitTo:evaluationsList.configPagination.itemsPerPage:evaluationsList.configPagination.firstElement; track client.evaluationId){
                  <div class="common-table-body__special-row">
                    <button class="common-button__icon-sm-noborder"
                      (click)="client.expanded = !client.expanded">
                      <i class="common-icon__md"
                        [ngClass]="client.expanded?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
                    </button>
                    <span-tooltip class="common-table-cell__standard-text-label"
                      [text]="client.clientName"></span-tooltip>
                    <div class="common-badge__badge-block">
                      <span class="common-badge__square-sm">{{client.evaluations?.length}}</span>
                    </div>
                  </div>
                  @if (client.expanded){
                    <evaluation-blanqueo-row
                      [evaluationsListFilter]="evaluationsList.evaluationsListFilter"
                      [view]="evaluationsList.view"
                      [client]="client"
                      [canCreate]="canCreate"
                      [searchEvaluation]="evaluationsList.searchEvaluation"
                      [filterTypes]="evaluationsList.filterTypes"
                      [filterOrder]="evaluationsList.filterOrder"
                      [order]="evaluationsList.order"
                      (emitEventRow)="emitEventFromRow($event)"></evaluation-blanqueo-row>
                  }
                }
              </div>
            }@else{
              <evaluation-blanqueo-row class="common-table-body__container-inner"
                [evaluationsListFilter]="evaluationsList.evaluationsListFilter"
                [view]="evaluationsList.view"
                [canCreate]="canCreate"
                [searchEvaluation]="evaluationsList.searchEvaluation"
                [filterTypes]="evaluationsList.filterTypes"
                [filterOrder]="evaluationsList.filterOrder"
                [order]="evaluationsList.order"
                (emitEventRow)="emitEventFromRow($event)"></evaluation-blanqueo-row>
            }
        </div>
      </div>
    }
    <pagination-control
      [config]="evaluationsList.configPagination"
      [totalRecords]="evaluationsList.amountElements"
      [(resetPagination)]="evaluationsList.resetPagination"
      (currentPageChange)="changeCurrentPage($event)"></pagination-control>
  </div>
</div>

@if((productSelected?.productId === 'blanqueo' || productSelected?.productId ==='denunc' || (dashboardVersion === 2 && skin !== 'icam-red')) && canCreate){
  <pdf-table class="common__pdf-hidde-element"
    [configuration]="evaluationsList.configurationPdf"></pdf-table>
}
